import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=2ebdcc22&scoped=true&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=2ebdcc22&prod&scoped=true&lang=css&"
import style1 from "./MenuComponent.vue?vue&type=style&index=1&id=2ebdcc22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdcc22",
  null
  
)

export default component.exports